import React from "react";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./auth/AuthContext";
import ToastPortal from "./components/ToastPortal";

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <AuthProvider>
        <AppRoutes />
        <ToastPortal />
      </AuthProvider>
    </div>
  );
}

export default App;
